import axios from "axios";
import VGCarousel from "../../../ui/carousel/carousel";
import {VGRollup} from "vgrollup";

class VGSearch {
	static lastQuery = '';

	constructor() {
	}

	search(value) {
		if (value && value !== VGSearch.lastQuery) {
			let requestParams = this.requestParams || {};
			requestParams.search = value;

			axios.get('/catalog/search/lookup', {
				params: requestParams
			}).then((response) => {
				VGSearch.lastQuery = value;

				let view = response.data.view;

				let result = this.container.querySelector('.results');
				result.innerHTML = view;

				this.container.querySelector('.search-advanced--wrapper-content')
					?.scrollTo({top: 0, behavior: 'smooth'});

				/*[...result.querySelectorAll('.swiper')].forEach(el => {
					VGCarousel.init(el);
				});*/

				[...this.container.querySelectorAll('[data-rollup-content]')].forEach((element) => {
					let target = element.id,
						content = element.dataset.rollupContent || 'text';

					new VGRollup(target, {content: content});
				});
			});
		}

		return this;
	}

	setContainer(selector) {
		this.container = document.querySelector(selector);
		return this;
	}

	setRequestParams(params) {
		this.requestParams = params || {};
	}

	toggle(value) {
		return value ? this.open() : this.close();
	}

	open() {
		if (!document.body.classList.contains('search-open')) {
			document.body.classList.add('search-open');
		}
		return this;
	}

	close() {
		if (document.body.classList.contains('search-open')) {
			document.body.classList.remove('search-open');
		}
		return this;
	}
}

export default VGSearch;
